import ResendCode from './Component';

export default ResendCode;